import { Guid } from "@/Common/Models/Guid";
import { PatientTab, ProfileTab } from "@/Common/Models/Patient/PatientEnums";
import { RedirectTo } from "@/Common/Models/UI/Enums";
import * as LocalOperations from "@/Common/Operations/operations.local";
import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { RouterHistory } from "@/Common/Utilities/Router/RouterHistory";

interface IHyperLinkRedirectProps {
    id?: string;
    target: RedirectTo;
    redirectValue: Guid;
    text?: string;
    className?: string;
    IsUnderLined?: boolean;
    onClickCallback?: (args: { vlaue: Guid, target: RedirectTo }) => void;
    targetPatient?: Guid;
    listName?: string;
    onBeforeRedirect?: (operation: LocalEvent) => void;
    subject?: string;
    navigateToSubTab?: HyperLinkRedirectControlPatientProfileSubTabs;
}

class HyperLinkRedirectControl extends React.Component<IHyperLinkRedirectProps, never> {
    public render(): JSX.Element {
        return (
            <a id={this.props.id} className={this.props.className} onClick={this.onClick.bind(this)}> {this.props.text} </a>
        );
    }

    public onClick(e: React.MouseEvent): void {
        if (this.props.onClickCallback == null) {
            e.stopPropagation();
            var operation = new LocalEvent(LocalOperations.Misc.RedirectToTab);
            operation.AddItem("value", this.props.redirectValue);
            operation.AddItem("target", this.props.target);
            operation.AddItem("currentLocation", RouterHistory.location);
            operation.AddItem("targetPatient", this.props.targetPatient);
            operation.AddItem("listName", this.props.listName);
            operation.AddItem("subject", this.props.subject);
            operation.AddItem("navigateToSubTab", this.props.navigateToSubTab);

            if (this.props.onBeforeRedirect != null) {
                this.props.onBeforeRedirect(operation);
            }

            LocalEventDispatcher.dispatch(operation);
        }
        else {
            this.props.onClickCallback.apply(null, [{ vlaue: this.props.redirectValue, target: this.props.target }]);
        }
    }
}

class HyperLinkRedirectControlPatientProfileSubTabs {
    public secondaryTab: PatientTab = PatientTab.Profile;
    public thernaryTab?: ProfileTab; // this param is optional. we don't specify it, we skip that part.

    constructor(tab?: ProfileTab) {
        this.thernaryTab = tab;
    }

    public get operation(): number {
        switch (this.thernaryTab) {
            case ProfileTab.PopulationBasedFunding:
                return LocalPatientOperations.Profile.PatientBanner_ShowPopulationBasedFundingTab;
            case ProfileTab.Other:
                return LocalPatientOperations.Profile.OtherInfo_Redirect;
        }
    }
}

export { HyperLinkRedirectControl, HyperLinkRedirectControlPatientProfileSubTabs };
